import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCheck2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShieldCheck2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V18.1952L12 23.1043L3 18.1952V3ZM15.5607 10.25L14.5 9.18934L11 12.6893L9.5 11.1893L8.43934 12.25L11 14.8107L15.5607 10.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldCheck2;
